/**
 * Como qualquer tela abre a ficha de um produto. Funções PURAS.
 *
 * Mesma regra da ficha da OP ([[fichaDaOp]] em `app/ops/helpers`): a ficha vive na BARRA
 * DE ENDEREÇO, então a linha clicada escreve `?produto=<nome>` e o link pode ser mandado
 * para alguém. Abrir um produto fecha a ficha de OP que estivesse aberta, e vice-versa:
 * são o mesmo painel lateral, e dois abertos ao mesmo tempo não existem.
 */

import { FICHA_DA_OP_PARAM } from '@/app/ops/helpers/fichaDaOp';

/** A chave do produto aberto: `/curadoria-tempos?produto=CAMISETA FEM`. */
export const FICHA_DO_PRODUTO_PARAM = 'produto';

/** O que a linha escreve no endereço ao ser clicada. */
export function abrirFichaDoProdutoPatch(produto: string): Record<string, string | null> {
  return {
    [FICHA_DO_PRODUTO_PARAM]: produto.trim() === '' ? null : produto,
    [FICHA_DA_OP_PARAM]: null,
  };
}
